import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { DishServices } from "../../../../dish/services";
import { Globals } from "../../../../../globals";
import { MenuServices } from "../../../services";
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
/**
 * Generated class for the MenuPartialDishesSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-menu-partial-extras-dishes-select',
    templateUrl: 'menu-partial-extras-dishes-select.html',
})
export class MenuPartialExtrasDishesSelectPage {
    //datatable
    sorts = [
        { prop: 'name', dir: 'asc' }
    ];
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public dishServices: DishServices,
        public menuServices: MenuServices,
        public globals: Globals,
        private toastCtrl: ToastController,
        public translate: TranslateService) {
    }

    insert(element) {
        //Funcion que añadir al array de platos seleccionados para el menu
        if (!this.check(element.UID)) { //Buscamos si el plato ya esta anadido
            var _array = Array();

            if (element.type == 'dish') {
                _array['uid'] = element.UID;

                if (element.name_es != undefined) {
                    _array['name'] = element.name_es;
                } else {
                    _array['name'] = '';
                }
                if (element.name_ca != undefined) {
                    _array['name_ca'] = element.name_ca;
                } else {
                    _array['name_ca'] = '';
                }
                if (element.name_en != undefined) {
                    _array['name_en'] = element.name_en;
                } else {
                    _array['name_en'] = '';
                }
                if (element.name_de != undefined) {
                    _array['name_de'] = element.name_de;
                } else {
                    _array['name_de'] = '';
                }
                if (element.name_fr != undefined) {
                    _array['name_fr'] = element.name_fr;
                } else {
                    _array['name_fr'] = '';
                }
                if (element.name_it != undefined) {
                    _array['name_it'] = element.name_it;
                } else {
                    _array['name_it'] = '';
                }

                _array['allergens'] = element.allergens;
                _array['price'] = element.price;

                if (element.price_supplement != undefined) {
                    _array['price_static'] = element.price_supplement;
                } else {
                    _array['price_static'] = 0;
                }
                _array['type'] = element.type;

                let toast = this.toastCtrl.create({
                    message: this.translate.instant('general-plato') + ' ' + this.globals.nameLangSelectDish(element) + ' ' + this.translate.instant('instant-anadido-correctemente'),
                    duration: 3000,
                    position: 'bottom'
                });
                toast.present();

            } else {
                _array['uid'] = element.UID;

                if (element.name != undefined) {
                    _array['name'] = element.name;
                } else {
                    _array['name'] = '';
                }
                if (element.name_ca != undefined) {
                    _array['name_ca'] = element.name_ca;
                } else {
                    _array['name_ca'] = '';
                }
                if (element.name_en != undefined) {
                    _array['name_en'] = element.name_en;
                } else {
                    _array['name_en'] = '';
                }
                if (element.name_de != undefined) {
                    _array['name_de'] = element.name_de;
                } else {
                    _array['name_de'] = '';
                }
                if (element.name_fr != undefined) {
                    _array['name_fr'] = element.name_fr;
                } else {
                    _array['name_fr'] = '';
                }
                if (element.name_it != undefined) {
                    _array['name_it'] = element.name_it;
                } else {
                    _array['name_it'] = '';
                }

                _array['allergens'] = element.allergens;
                _array['price'] = element.pvp;

                if (element.pvp_supplement != undefined) {
                    _array['price_static'] = element.pvp_supplement;
                } else {
                    _array['price_static'] = 0;
                }
                _array['type'] = element.type;

                let toast = this.toastCtrl.create({
                    message: this.translate.instant('general-producto') + ' ' + this.globals.nameLangSelectProduct(element) + ' ' + this.translate.instant('instant-anadido-correctemente'),
                    duration: 3000,
                    position: 'bottom'
                });
                toast.present();
            }
            this.menuServices.menu_dish_product_array_tmp.push(_array);
            this.menuServices.menu_dish_product_array_tmp = [...this.menuServices.menu_dish_product_array_tmp];
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-elemento-anadido-lista'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    check(value) {
        var response = false;
        for (var i = 0; i < this.menuServices.menu_dish_product_array_tmp.length; i++) {
            var obj = this.menuServices.menu_dish_product_array_tmp[i];
            if (obj.uid == value) {
                response = true;
            }
        }
        return response;
    }
    nextPage() {
        if (this.menuServices.page_active < this.menuServices.pagesDishesProducts.length) {
            this.menuServices.page_active += 1
        }
        this.menuServices.getListDishesProductsMinMax();
    }
    previusPage() {
        if (this.menuServices.page_active > 1) {
            this.menuServices.page_active -= 1;
        }
        this.menuServices.getListDishesProductsMinMax();
    }
    activePage(number) {
        this.menuServices.page_active = number;
        this.menuServices.getListDishesProductsMinMax();
    }
    clickElement(event) {
        if (event.type == 'click') {
            this.insert(event.row);
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/menu/menu-create/menu-create-extras/menu-partial-extras-dishes-select/menu-partial-extras-dishes-select.ts